export const AUTO_ADVANCE_MS = 10_000
export const TRANSITION_MS = 500
/** Repeated copies keep the active tab in the center without a hard edge. */
export const COPIES = 7

export const STEP_CONTENT = [
  {
    titleKey: 'Landing.Text.HowItWorksChooseDestination',
    descriptionKey: 'Landing.Text.HowItWorksChooseDestinationDescription',
    image: '/landing/how-it-works-choose-destination.png',
  },
  {
    titleKey: 'Landing.Text.HowItWorksChoosePlan',
    descriptionKey: 'Landing.Text.HowItWorksChoosePlanDescription',
    image: '/landing/how-it-works-choose-plan.png',
  },
  {
    titleKey: 'Landing.Text.HowItWorksCheckout',
    descriptionKey: 'Landing.Text.HowItWorksCheckoutDescription',
    image: '/landing/how-it-works-checkout.png',
  },
  {
    titleKey: 'Landing.Text.HowItWorksInstall',
    descriptionKey: 'Landing.Text.HowItWorksInstallDescription',
    image: '/landing/how-it-works-instalation.png',
  },
  {
    titleKey: 'Landing.Text.HowItWorksUsage',
    descriptionKey: 'Landing.Text.HowItWorksUsageDescription',
    image: '/landing/how-it-works-usage.png',
  },
] as const

export type HowItWorksStep = {
  title: string
  description: string
  image: string
}
